
import Routing from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-quill/dist/quill.snow.css';

import "./App.css";
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Routing />
    </div>
  );
}
export default App;
